import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import NiceModal from '@ebay/nice-modal-react';
import { Redirect } from 'react-router-dom';
import { FEATURE_FLAG } from 'itrvl-types';

import ItineraryBuilder from './ItineraryBuilder';
import { useUser } from 'common/hooks/user';

import ThemeProvider from 'components/v2/ThemeProvider';

import { useBuilderStore } from './store';
import { useEffect } from 'react';
import { useApi } from 'common/hooks/api';

import logger from 'itrvl-logger';
const log = logger(__filename);
log.trace(__filename);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * This is mostly to wire up the different providers that belong to just the
 * ItineraryBuilder subtree.
 *
 * @todo: This can go away partially/completely depending on the adoption of the various libraries
 *
 * @param {*} props
 * @returns A react component tree
 */
const ItineraryBuilderEntry = () => {
  // need to inject Api so it's available in the store, for now
  // @todo: remove me once we refactor fetches
  const Api = useApi();
  const setApi = useBuilderStore(state => state.actions.api.setApi);
  useEffect(() => {
    setApi && Api && setApi(Api);
  }, [Api, setApi]);

  const user = useUser();

  // need to inject Feature flag for RestOfWorld
  const setFilter = useBuilderStore(state => state.actions.settings.setFilter);
  useEffect(() => {
    setFilter && setFilter(user?.agency?.[FEATURE_FLAG.REST_OF_WORLD] ? true : false);
  }, [user?.agency, setFilter]);

  // redirect if you don't have the flag
  // @todo: this can be removed once the feature is live
  if (user?.agency?.[FEATURE_FLAG.ITINERARY_BUILDER_2] !== true) {
    return <Redirect to="/" />;
  }

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <NiceModal.Provider>
          <ItineraryBuilder />
        </NiceModal.Provider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default ItineraryBuilderEntry;
